/**
 * Tribe community mixin
 */
import { TribeCommunityUrl } from '@/plugins/tribe.client.js';

export default {

    computed: {
        TribeCommunityUrl: () => TribeCommunityUrl
    },

    // components: {
    //     TribeWidget: () => import('@/components/Tribe/TribeWidget.vue')
    // },

    methods: {

        getTribeCommunityUrl: function () {
            return this.TribeCommunityUrl;
        },

        getCommunityDisabled: function () {
            return this.item?.CommunityDisabled;
        },

        communityAllowAnon: function () {
            return this.$store.getters['ux/getCommunityAllowAnon'];
        },

        isAuthenticated: function () {
            return this.$store.getters['user/isAuthenticated'];
        },

        allowCommunity: function () {
            return this.communityAllowAnon() || this.isAuthenticated();
        }
    }
};
